import { connect } from 'react-redux';

import { actionOpenModal } from 'store/global/modal/actions';
import {
  CREATE_NEW_ROOM,
  UPDATE_ROOM_OF_PLACE,
  GET_ROOM_DETAIL_OF_PLACE,
  DELETE_ROOM_OF_PLACE,
} from 'store/room/actionTypes';
import { GET_PLACE_DETAIL } from 'store/place/actionTypes';
import {
  GET_PLACE_OTA_DATA,
  GET_ROOM_PRICE_TYPES,
  UPDATE_ROOM_PRICE_TYPES,
} from 'store/room-price-type/actionTypes';

import CreateNewRoom from './CreateNewRoom';

const mapStateToProps = (state) => ({
  isLoadingCreateNewRoom: state.Room.isLoadingCreateNewRoom,
  isLoadingUpdateRoomOfPlace: state.Room.isLoadingUpdateRoomOfPlace,
  isLoadingGetRoomDetailOfPlace: state.Room.isLoadingGetRoomDetailOfPlace,
  isLoadingGetPlaceOtaData: state.RoomPriceType.isLoadingGetPlaceOtaData,
  isLoadingGetRoomPriceTypes: state.RoomPriceType.isLoadingGetRoomPriceTypes,
  isLoadingUpdateRoomPriceTypes: state.RoomPriceType.isLoadingUpdateRoomPriceTypes,

  placeDetail: state.Place.placeDetail,
  placeOtaData: state.RoomPriceType.placeOtaData,
  roomDetailOfPlace: state.Room.roomDetailOfPlace,
  roomPriceTypes: state.RoomPriceType.roomPriceTypes,
  setting: state.Setting.setting,
});

const mapDispatchToProps = (dispatch) => ({
  actionCreateNewRoom: (payload) => dispatch({
    type: CREATE_NEW_ROOM,
    payload,
  }),

  actionUpdateRoomOfPlace: (payload) => dispatch({
    type: UPDATE_ROOM_OF_PLACE,
    payload,
  }),

  actionGetRoomDetailOfPlace: (payload) => dispatch({
    type: GET_ROOM_DETAIL_OF_PLACE,
    payload,
  }),

  actionDeleteRoomOfPlace: (payload) => dispatch({
    type: DELETE_ROOM_OF_PLACE,
    payload,
  }),

  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionGetRoomPriceTypes: (payload) => dispatch({
    type: GET_ROOM_PRICE_TYPES,
    payload,
  }),

  actionGetPlaceOtaData: (payload) => dispatch({
    type: GET_PLACE_OTA_DATA,
    payload,
  }),

  actionUpdateRoomPriceTypes: (payload) => dispatch({
    type: UPDATE_ROOM_PRICE_TYPES,
    payload,
  }),

  actionOpenModalCreateSuccess: (payload) => dispatch(actionOpenModal(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewRoom);
